
export class PlanGoodsEcology1Model {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 環境区分フラグ
  public ecologyDivFlag: string = <string>'';
}
